var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-col',_vm._b({},'a-col',_vm.colResponsive,false),[_c('div',{staticClass:"term"},[(_vm.term)?_c('span',[_vm._v(_vm._s(_vm.term))]):_vm._e(),_vm._t("term")],2),_c('div',{staticClass:"detail"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }